module.exports = __webpack_public_path__ + "img/london-25.85211d86.png";